import {RaisedButton} from 'material-ui';
import styled from 'styled-components';

import {Col} from '../Grid';

export const FormRow = styled.div`
  padding: 10px 15px;
`;

export const CheckBoxStyles = {display: 'inline-block', width: 200};

export const NewButton = styled.div`
  margin-top: 15px;
  padding: 0 10px;
  height: 40px;
  display: inline-block;
  float: right;
  font-size: 25px;
  font-weight: 200;
  lineheight: 40px;
  margin-right: 2%;
  background: ${props => props.theme.primaryColor};
  a,
  a:hover {
    color: white;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 2%;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 50%;
`;

export const TopBar = styled.div`
  position: fixed;
  left:0
  top: 0;
  right: 0;
  height: 70px;
  background: white;
  border-bottom: 4px solid ${props => props.theme.primaryColor};
  box-shadow: 0 8px 6px -6px #999;
  z-index: 100;
`;

export const TopBarLeftCol = styled(Col)`
  padding-left: 100px;
`;

export const TopBarButton = styled(RaisedButton)`
  margin-top: 15px;
  margin-right: 15px;
`;



// WEBPACK FOOTER //
// ./src/components/form/FormElements.js